






import Vue from 'vue';

export default Vue.extend({
  name: "JailMain2d",
  data: () => {
    return {};
  },
});
